import { saveManageContext } from "../checkin/manageContext";

function clientInitials(name = "") {
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0] || ""}${parts[1][0] || ""}`.toUpperCase();
  }
  return String(name).slice(0, 2).toUpperCase() || "CL";
}

export { clientInitials };

export function buildClientPortalSignoffContext(row, accountId) {
  const email =
    localStorage.getItem("manageEmail") ||
    localStorage.getItem("userEmail") ||
    "";
  return {
    accountId: accountId ? Number(accountId) : null,
    clientId: row.clientId,
    clientName: row.name,
    email,
    capabilities: row.capabilities || null,
    selectedLocationIds: Array.isArray(row.clientLocationIds)
      ? row.clientLocationIds
      : [],
    modifyUnpaidBreak: row.modifyUnpaidBreak,
    timesheetReviewRequired: row.timesheetReviewRequired,
  };
}

export function navigateToClientSignoff(navigate, row, accountId) {
  const manageContext = buildClientPortalSignoffContext(row, accountId);
  saveManageContext(manageContext);

  const params = new URLSearchParams();
  params.set("clientId", String(row.clientId));
  params.set("scope", "multiday");

  navigate(`/manage/signoff?${params.toString()}`, {
    state: { manageContext },
  });
}
